import React from "react";

/**
 * ResyNote logo.
 * A research notebook/flask mark: overlapping pages + a science orbit/atom ring.
 * - size: number (pixel dimension for both width and height)
 * - className: extra classes
 * - variant: 'mark' (icon only) | 'lockup' (mark + wordmark)
 */
export default function Logo({ size = 32, className = "", variant = "mark", wordmarkClassName = "" }) {
  const Mark = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="ResyNote"
      role="img"
    >
      {/* Rounded-square tile with subtle gradient */}
      <defs>
        <linearGradient id="rn-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#2563eb" />
          <stop offset="100%" stopColor="#1d4ed8" />
        </linearGradient>
      </defs>
      <rect width="40" height="40" rx="9" fill="url(#rn-bg)" />

      {/* Orbit ring — represents research / hypothesis */}
      <ellipse
        cx="20"
        cy="20"
        rx="13"
        ry="5.5"
        transform="rotate(-28 20 20)"
        stroke="#ffffff"
        strokeOpacity="0.35"
        strokeWidth="1.2"
        fill="none"
      />
      {/* Nucleus */}
      <circle cx="20" cy="20" r="1.6" fill="#ffffff" fillOpacity="0.9" />

      {/* Notebook — two pages, the front one tilted */}
      <g>
        {/* Back page */}
        <rect
          x="12"
          y="10"
          width="14"
          height="19"
          rx="1.8"
          fill="#ffffff"
          fillOpacity="0.25"
        />
        {/* Front page */}
        <rect
          x="13.5"
          y="12"
          width="14"
          height="19"
          rx="1.8"
          fill="#ffffff"
        />
        {/* Ruled lines on the front page */}
        <path
          d="M16.2 17h9M16.2 20.5h9M16.2 24h6.5"
          stroke="#2563eb"
          strokeWidth="1.1"
          strokeLinecap="round"
          strokeOpacity="0.85"
        />
        {/* Bookmark / binding */}
        <rect x="13.5" y="12" width="2" height="19" fill="#1d4ed8" fillOpacity="0.85" />
      </g>
    </svg>
  );

  if (variant === "mark") return Mark;

  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      {Mark}
      <span className={`font-sans font-bold tracking-tight ${wordmarkClassName}`}>
        Resy<span className="text-blue-600">Note</span>
      </span>
    </span>
  );
}
